/**
 * Created by valentin on 20/07/2017.
 */
import moment from 'moment'
import {polyglot} from '../index'
import { getImage } from '../components/general/TeethView/DataImages'

export const alertOptions = {
  offset: 14,
  position: 'bottom left',
  theme: 'dark',
  time: 5000,
  transition: 'scale'
}

export function isDateInputAvailable () {
  let input = document.createElement('input')
  input.setAttribute('type', 'date')

  let notADateValue = 'not-a-date'
  input.setAttribute('value', notADateValue)

  return (input.value !== notADateValue)
}

export function calculateYears (value) { // miliseconds from epoch
  return value / 31536000000
}

export function patientOlderThenAge (patientBirthDate, currentAgeStart) {
  const patientBirth = moment(patientBirthDate)
  const patientAgeValue = moment().diff(patientBirth)
  return patientAgeValue > currentAgeStart
}

export function calculateAge (interval) {
  const start = interval.start
  const end = interval.end
  const result = {
    start: null,
    end: null,
    designation: null
  }
  if (end !== undefined) {
    const startValue = parseInt(calculateYears(start), 10)
    const endValue = parseInt(calculateYears(end), 10)
    result.designation = startValue + '-' + endValue + ' ' + polyglot.t('commonFields.years')
    result.start = start
    result.end = end
  } else {
    result.start = start
    result.designation = interval.designation
  }
  return result
}

export function checkSelected (elements, value) {
  if (elements && elements !== null) {
    return elements.indexOf(value) !== -1
  } else {
    return false
  }
}

export function getFormattedDate (date, formatType) {
  return moment(date).format(formatType)
}

export function getFormattedBirthDate (birthday) {
  return moment(birthday).format('LL')
}

export function getAgeDescription (birthday) {
  let patientBirthDay = moment(birthday)
  let years = moment().diff(patientBirthDay, 'years', false)
  return years + ' ' + polyglot.t('commonFields.years')
}

export function getTooth (toothId, toothState) {
  return getImage(`${toothId}_${toothState}`)
}

export function getDescriptionForAge (age) {
  if (age <= 12) {
    return polyglot.t('staticFields.numMonths', {smart_count: age})
  } else {
    let years = Math.floor(age / 12)
    return polyglot.t('staticFields.numYears', {smart_count: years})
  }
}

export function takeCanvasScreenshot () {
  return window.document.getElementById('canvas').toDataURL()
}

/**
 * @return {boolean}
 */
export function isJsonString (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/resources/utilities.js